import { Loader } from 'semantic-ui-react'
import { StyledSubMenuItem } from '.'
import Popup from 'shared/components/Popup'
import { getLoading, getPageList } from './FeedbackSubMenu'
import { useNavbarMenuContext } from './context'
import React from 'react'

export function FavoriteDashboardSurveyList({
  workspaceToken,
  hasViewCustomDashboardsPermisison,
  hasViewSurveyDashboardsPermission,
}) {
  const context = useNavbarMenuContext()
  const favoriteDashboardSurveyPages = getPageList('favoriteDashboardSurveyPages', context)
  if (!hasViewCustomDashboardsPermisison && !hasViewSurveyDashboardsPermission) {
    return null
  }
  if (getLoading('favoriteDashboardSurveyPagesLoading', context)) {
    return <Loader className="ml-5 !z-[-1]" />
  } else if (favoriteDashboardSurveyPages.length === 0) {
    return null
  } else {
    return (
      <React.Fragment>
        <StyledSubMenuItem
          className="sub-menu-title item disable pointer-events-none"
          to="/feedback/"
        >
          <span>Favorites</span>
        </StyledSubMenuItem>

        {favoriteDashboardSurveyPages.map((view) => {
          if (view.type == 'dashboard' && hasViewCustomDashboardsPermisison) {
            return (
              <Popup.Truncated key={view.token} content={view.name}>
                <StyledSubMenuItem
                  className="sub-menu-item item"
                  isActive={(_, location) =>
                    location.pathname.includes(`/dashboards/${view.token}`)
                  }
                  to={{
                    pathname: `/${workspaceToken}/dashboards/${view.token}/`,
                    state: { useStickyFilter: false, dashboardName: view.name },
                  }}
                >
                  {view.name}
                </StyledSubMenuItem>
              </Popup.Truncated>
            )
          } else if (view.type == 'survey' && hasViewSurveyDashboardsPermission) {
            const displayName = view.is_default_view
              ? view.survey_name
              : `${view.name} (${view.survey_name})`
            return (
              <Popup.Truncated key={view.token} content={displayName}>
                <StyledSubMenuItem
                  className="sub-menu-item item"
                  isActive={(_, location) =>
                    location.pathname.includes(`/dashboards/views/${view.token}`)
                  }
                  to={{
                    pathname: `/${workspaceToken}/dashboards/views/${view.token}/overview/`,
                    state: { useStickyFilter: false, viewName: view.name },
                  }}
                >
                  {displayName}
                </StyledSubMenuItem>
              </Popup.Truncated>
            )
          }
        })}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/NavBar/FavoriteDashboardSurverList.js